import { UniDriver } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { closeButtonDriverFactory } from '../CloseButton/CloseButton.uni.driver';

const toastDismissButtonDriverFactory = (base: UniDriver) => {
  const { exists, element, click, getAriaLabel, isButtonDisabled } =
    closeButtonDriverFactory(base);

  return {
    exists,
    element,
    click,
    getAriaLabel,
    isDisabled: isButtonDisabled,
  };
};

export const toastDriverFactory = (base: UniDriver) => {
  const dismissButton = toastDismissButtonDriverFactory(
    base.$('[data-hook="toast-dismiss-button"]'),
  );

  return {
    ...baseUniDriverFactory(base),
    getRole: async () => base.attr('role'),
    getAriaLive: async () => base.attr('aria-live'),
    isVisible: async () => (await base.attr('aria-hidden')) === 'false',
    isDismissible: async () => dismissButton.exists(),
    /** @deprecated use dismissButton **/
    getDismissButton: async () => dismissButton,
    dismissButton,
  };
};

export type ToastUniDriver = ReturnType<typeof toastDriverFactory>;
